// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions[data-v-59fb5126]{gap:8px 16px;padding-bottom:24px}.image[data-v-59fb5126]{display:block;height:auto;width:100%}@media only screen and (min-width:960px){.actions[data-v-59fb5126]{padding-bottom:0}.text[data-v-59fb5126]{padding-right:32px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
